import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isSilent = req.headers.has('X-Silent');
    req.headers.delete('X-Silent');

    if (!isSilent) {
      this.loadingService.showLoading();
    }

    return next.handle(req).pipe(finalize(() => {
      if (!isSilent) {
        this.loadingService.hideLoading();
      }
    }));
  }
}
